<template>
    <div class="layout-normal">
        <!-- Layout Builder -->
        <div class="form-row" v-for="row in form.layout">
            <div :class="columnClass(field, errors)" v-for="field in row">
                <template v-if="field.type === 'number'">
                    <form-label :field="field"></form-label>
                    <input-number :field="field" :v-model="'formData.'+field.handle"></input-number>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <div v-else-if="field.type === 'html'" v-html="field.value"></div>
                <template v-else-if="field.type === 'textarea'">
                    <form-label :field="field"></form-label>
                    <input-textarea :field="field"></input-textarea>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'datetime'">
                    <form-label :field="field"></form-label>
                    <input-date-time :field="field"></input-date-time>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'file'">
                    <form-label :field="field"></form-label>
                    <input-file :field="field"></input-file>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'submit'">
                    <input-submit :field="field" :instance="instance"></input-submit>
                </template>
                <template v-else-if="field.type === 'mailing_list'" v-show="!field.mailingList.hidden">
                    <form-label :field="field"></form-label>
                    <input-mailing-list :field="field"></input-mailing-list>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'checkbox'">
                    <form-label :field="field"></form-label>
                    <input-checkbox :field="field"></input-checkbox>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'email'">
                    <form-label :field="field"></form-label>
                    <input-email :field="field"></input-email>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'select'">
                    <form-label :field="field"></form-label>
                    <input-select :field="field"></input-select>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'multiple_select'">
                    <form-label :field="field"></form-label>
                    <input-multi-select :field="field"></input-multi-select>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'radio_group'">
                    <form-label :field="field"></form-label>
                    <input-radio-group :field="field"></input-radio-group>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'checkbox_group'">
                    <form-label :field="field"></form-label>
                    <input-checkbox-group :field="field"></input-checkbox-group>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'hidden'">
                    <input-hidden :field="field"></input-hidden>
                </template>
                <template v-else-if="field.type === 'invisible'">
                    <input-invisible :field="field"></input-invisible>
                </template>
                <template v-else-if="field.type === 'password'">
                    <form-label :field="field"></form-label>
                    <input-text :field="field"></input-text>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'phone'">
                    <form-label :field="field"></form-label>
                    <input-phone :field="field"></input-phone>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'confirmation'">
                    <form-label :field="field"></form-label>
                    <input-confirmation :field="field"></input-confirmation>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'website'">
                    <form-label :field="field"></form-label>
                    <input-website :field="field"></input-website>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'regex'">
                    <form-label :field="field"></form-label>
                    <input-regex :field="field"></input-regex>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'opinion_scale'">
                    <form-label :field="field"></form-label>
                    <input-opinion-scale :field="field"></input-opinion-scale>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'rating'">
                    <form-label :field="field"></form-label>
                    <input-rating :field="field"></input-rating>
                    <form-instructions :field="field"></form-instructions>
                </template>
                <template v-else-if="field.type === 'text'">
                    <template v-if="field.handle === 'pageSource' || field.handle === 'selectedInstaller'">
                        <input-hidden :field="field"></input-hidden>
                    </template>
                    <template v-else>
                        <form-label :field="field"></form-label>
                        <input-text :field="field"></input-text>
                        <form-instructions :field="field"></form-instructions>
                    </template>

                </template>
                <template v-else>
                    Missing field type: {{ field.type }}
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import FormLabel from "../FormLabel";
    import FormInstructions from "../FormInstructions";
    import InputTextarea from "../Fields/Textarea";
    import InputText from "../Fields/Text";
    import InputNumber from "../Fields/Number";
    import InputSubmit from "../Fields/Submit";
    import InputFile from "../Fields/File";
    import InputEmail from "../Fields/Email";
    import InputMailingList from "../Fields/MailingList";
    import InputSelect from "../Fields/Select";
    import InputCheckbox from "../Fields/Checkbox";
    import InputMultiSelect from "../Fields/MultiSelect";
    import InputRadioGroup from "../Fields/RadioGroup";
    import InputCheckboxGroup from "../Fields/CheckboxGroup";
    import InputHidden from "../Fields/Hidden";
    import InputDateTime from "../Fields/Pro/DateTime";
    import InputInvisible from "../Fields/Pro/Invisible";
    import InputPhone from "../Fields/Pro/Phone";
    import InputConfirmation from "../Fields/Pro/Confirmation";
    import InputWebsite from "../Fields/Pro/Website";
    import InputRegex from "../Fields/Pro/Regex";
    import InputOpinionScale from "../Fields/Pro/OpinionScale";
    import InputRating from "../Fields/Pro/Rating";

    export default {
        name: 'layout-normal',
        props: {
            instance: {
                required: true,
            },
            form: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
        },
        components: {
            FormLabel,
            FormInstructions,
            InputTextarea,
            InputText,
            InputNumber,
            InputSubmit,
            InputDateTime,
            InputFile,
            InputMailingList,
            InputEmail,
            InputSelect,
            InputCheckbox,
            InputMultiSelect,
            InputRadioGroup,
            InputCheckboxGroup,
            InputHidden,
            InputInvisible,
            InputPhone,
            InputConfirmation,
            InputWebsite,
            InputRegex,
            InputOpinionScale,
            InputRating,
        },
        methods: {
            columnClass: function (field, errors) {
                let className = 'col-12 col-sm-12 col-md-12 col-lg-' + field.width
                    + ' field-type-' + field.type + ' field-handle-' + field.handle;

                if (errors[field.handle] && errors[field.handle].length) {
                    className += ' has-error';
                }

                return className;
            },
        },
    }
</script>